var MantleCarousel = MantleCarousel || {};
var MantleWindow = MantleWindow || {};
var prodcat = prodcat || {};
var site = site || {};

(function ($, Unison) {
  const enableMobileCarouselProductFull = false;

  const slidesToShow = 5;
  const slidesToShowResponsive = 7;

  const productBriefClass = 'product-brief__shade-picker';
  const productFullClass = 'product-full__shadepicker';

  function isSoldOutReorderingEnabled() {
    return typeof Drupal !== 'undefined' &&
           Drupal.settings &&
           Drupal.settings.global_variables &&
           Drupal.settings.global_variables.sort_shades_by_inventory;
  }

  function sortTFShadesAndInventory($slider) {
    if (isSoldOutReorderingEnabled()) {
      var $children = $slider.children('.js-shade-picker-item:not(.slick-cloned)');

      $children.each(function(index) {
        if (!$(this).attr('data-original-index')) {
          $(this).attr('data-original-index', index);
        }
      });

      $children.detach().sort(function(a, b) {
        var $a = $(a);
        var $b = $(b);

        var $shadeA = $a.find('.js-product-shade').length ? $a.find('.js-product-shade') : $a;
        var $shadeB = $b.find('.js-product-shade').length ? $b.find('.js-product-shade') : $b;

        var skuIdA = $shadeA.data('sku');
        var skuIdB = $shadeB.data('sku');

        var skuDataA = (typeof prodcat !== 'undefined' && skuIdA) ? prodcat.data.getSku(skuIdA) : null;
        var skuDataB = (typeof prodcat !== 'undefined' && skuIdB) ? prodcat.data.getSku(skuIdB) : null;

        var weightA = 0;
        if (skuDataA) {
          if (skuDataA.INVENTORY_STATUS === 2) weightA = 1;
          else if (skuDataA.INVENTORY_STATUS === 7) weightA = 2;
        }

        var weightB = 0;
        if (skuDataB) {
          if (skuDataB.INVENTORY_STATUS === 2) weightB = 1;
          else if (skuDataB.INVENTORY_STATUS === 7) weightB = 2;
        }

        if (weightA !== weightB) {
          return weightA - weightB;
        }

        var orderA = parseInt($a.attr('data-display-order'), 10);
        var orderB = parseInt($b.attr('data-display-order'), 10);

        if (isNaN(orderA)) orderA = parseInt($a.attr('data-original-index'), 10);
        if (isNaN(orderB)) orderB = parseInt($b.attr('data-original-index'), 10);

        return orderA - orderB;
      }).appendTo($slider);
    }
  }

  function _setSmooshColor(skuId, $product) {
    var $smoosh = $('.js-product-smoosh', $product);
    var sku;

    if (skuId) {
      sku = prodcat.data.getSku(skuId);
      if (sku && sku.HEX_VALUE_STRING) {
        $smoosh.css('background-color', sku.HEX_VALUE_STRING);
      }
    }
  }

  $(document).on('click', '.product-shade-picker__shade_family', function () {
    var $menu = $(this);
    var $product = $(this).closest('.js-product');
    var $menuLinks = $('.product-shade-picker__shade_family', $product);

    $menuLinks.removeClass('active');
    $menu.addClass('active');

    var $slider = $('.product-shade-picker__shades', $product);

    var selectedFamily = $menu.data('shade-family');
    var $shades = $('.js-product-shade', $product);

    // Create a reference to the active shade and remove the active class before filtering the shades.
    // That way the old active shade doesn't return if it's no longer valid in the new shade family.
    var $prevActiveShade = $('.js-product-shade.active', $product);
    $shades.removeClass('active');

    $shades.each(function (i, obj) {
      var $shade = $(obj);
      var _family = $shade.data('shade-family');
      var $shadeItem = $shade.parent(); // shades have a wrapper

      if (selectedFamily === 'all') {
        $shadeItem.removeClass('shade-hidden');
        return;
      }
      if (_family && _.includes(_family.split(','), selectedFamily)) {
        $shadeItem.removeClass('shade-hidden');
        return;
      }
      // process hidden shades
      $shadeItem.addClass('shade-hidden');
    });

    $menu.trigger('shadePicker:visible-shade-change');

    // *
    // * Early returns if the active shade exists in the selected family.
    // * The shade should remain active with no change.
    // *
    var familyOfActiveShade = $prevActiveShade.data('shade-family');

    if (selectedFamily === 'all') {
      handleShadeClick.call($prevActiveShade);
      $slider.trigger('shadePicker:visible-shade-change');
      return;
    }

    if (familyOfActiveShade && _.includes(familyOfActiveShade.split(','), selectedFamily)) {
      handleShadeClick.call($prevActiveShade);
      $slider.trigger('shadePicker:visible-shade-change');
      return;
    }

    // *
    // * When selecting a shade family, if the previously active shade is not in this new family,
    // * Replace the active shade to the first in the new family.
    // *
    const $replacementShade = $('.js-shade-picker-item:not(.shade-hidden)', $product)
      .first()
      .find('.js-product-shade');
    handleShadeClick.call($replacementShade);
    $slider.trigger('shadePicker:visible-shade-change');
  });

  function handleShadeClick(e) {

    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }

    var $shade = $(this);
    var $products;
    var productId;
    var skuId = $shade.data('sku');
    var productDelay = 50;

    if (!skuId) {
      return;
    }

    var sku = prodcat.data.getSku(skuId);

    if (!sku || $shade.hasClass('active')) {
      return;
    }

    var skuBaseId = sku.SKU_BASE_ID;
    var $product = $shade.closest('.js-product');
    var $shadeLabel = $('.js-product-shade-picker-label', $product);
    var $allShadeDots = $('.js-product-shade', $product);

    productId = $product.data('product-id');

    // Toggle the active state of the selected shades
    $shade.closest('.js-product-shade-picker').find('.js-product-shade').removeClass('active');

    $allShadeDots.removeClass('active');

    $shade.addClass('active');
    $shadeLabel.animate({ opacity: 0 }, 0, 'linear', function () {
      $shadeLabel.text($shade.attr('title'));
      $shadeLabel.animate({ opacity: 1 }, 750, 'linear');
    });

    // Search for the same shade in duplicated products and trigger the event on them as well
    var $slider = $shade.closest('.product-shade-picker__shades');
      if ($slider.hasClass('slick-initialized')) {
        var $shadeItem = $shade.closest('.js-shade-picker-item');
        var slideIndex = $shadeItem.data('slick-index');
        if (typeof slideIndex !== 'undefined' && slideIndex !== null) {
          $slider.slick('slickGoTo', parseInt(slideIndex, 10));
        }
      }
      if (productId && (!e || !e.isTrigger)) {
      $products =$product
        .closest('.js-product-carousel')
        .find(`.js-product[data-product-id="${productId}"]`)
        .not($product);

      $products.each(function () {
        var $prodItem = $(this);
        var $duplicatedShade = $prodItem.find(
          `.product-shade-picker__shades .js-product-shade[data-sku="${skuId}"]`
        );

        if ($duplicatedShade.length > 0 && !$duplicatedShade.hasClass('active')) {
          handleShadeClick.call($duplicatedShade);
        }
      });
    }

    setTimeout(() => {
      $product.trigger('product.skuSelect', [skuBaseId]);
    }, productDelay);
  }

  // Check if shade picker is nested and parent carousel is initialized
  async function waitForParentInitialized($shadepicker) {
    var $parentCarousel = $shadepicker.closest('.js-product-carousel');

    if ($parentCarousel.length > 0) {
      if ($parentCarousel.hasClass('slick-initialized')) {
        return true;
      }

      // Create timer to wait for parent carousel to initialize
      return new Promise((resolve) => {
        var interval = setInterval(function () {
          if ($parentCarousel.hasClass('slick-initialized')) {
            clearInterval(interval);
            resolve(true);
          }
        }, 100);
      });
    }

    // If no parent carousel, return true
    return true;
  }

  $(document).on('click', '.js-product-shade', handleShadeClick);


  /*
   * When activating a shade from the selectbox, the newly active shade might not be in the current family.
   * If the newly active shade is not in the current active shade family, then default to "all".
   */
  $(document).on('shadePicker:ensureActiveFamily', function (event,$product) {
    var $all_link = $('.product-shade-picker__shade_family[data-shade-family="all"]', $product);
    var selectedFamily = $('.product-shade-picker__shade_family.active').data('shade-family');
    var familyOfActiveShade = $('.js-product-shade.active', $product).data('shade-family');

    if (selectedFamily === 'all') {
      return;
    }

    if (familyOfActiveShade && _.includes(familyOfActiveShade.split(','), selectedFamily)) {
      return;
    }

    $all_link.trigger('click');
  });

  $(document).on('product.skuSelect', '.js-product', function (event, skuBaseId) {
    var $product = $(this);

    $product.triggerHandler('shadePicker:selectShade', [skuBaseId]);
  });

  $('.js-product-shade').on('mouseenter', function () {
    var $shade = $(this);
    var $product = $shade.closest('.js-product');
    var skuBaseId = $shade.data('sku');

    $shade.trigger('shadePickerShade:hover-in', [skuBaseId]);
    _setSmooshColor(skuBaseId, $product);
  });

  $(document).on('mouseleave', '.js-product-shade', function () {
    var $shade = $(this);
    var $product = $shade.closest('.js-product');
    var skuBaseId = $shade.data('sku');

    $shade.trigger('shadePickerShade:hover-out', [skuBaseId]);
    _setSmooshColor(skuBaseId, $product);
  });

  $(document).on('shadePicker:visible-shade-change', '.js-product-shade-picker', function () {
    var $shadepicker = $(this);
    var $product = $shadepicker.closest('.js-product');
    var $visibleShades = $('.js-product-shade:visible', $shadepicker);
    var $allShadeItems = $('.js-shade-picker-item', $shadepicker);
    var visibleShadeCount = $visibleShades.length;

    $shadepicker.removeClass('has-missing-shades');

    var productId = $product.data('product-id');
    var prodData = prodcat.data.getProduct(productId);

    if (!prodData || !prodData.skus) {
      return;
    }

    var totalSkus = prodData.skus.length;
    var missingSkus = totalSkus - visibleShadeCount;

    if (missingSkus > 0) {
      $shadepicker.addClass('has-missing-shades');
    }

    // if this class is set. that means that all shades are visible. so ntohing
    // to calculate. we use visible so css can be what defines the visiblity
    if (!$shadepicker.hasClass('show-shade-overflow')) {
      var notCssVisibilityHidden = 0;

      // note :visible only works with display none
      $allShadeItems.each(function (i, obj) {
        var $shade_item = $(obj);

        if ($shade_item.css('visibility') !== 'hidden') {
          notCssVisibilityHidden++;
        }
      });
      if ($allShadeItems.length > notCssVisibilityHidden) {
        $shadepicker.addClass('has-shade-overflow');
      }
    }

    $('.js-show-shade-overflow', $shadepicker).off('click.overflow').on('click.overflow', function (e) {
      e.preventDefault();$shadepicker.toggleClass('show-shade-overflow');
    });

    $('.js-missing-shades', $shadepicker).text(missingSkus);
  });

  Drupal.behaviors.productShadePicker = {
    observer: null,
    setupObserver: function () {
      var self = this;

      if (self.observer !== null) {
        return;
      }
      var handler = function (entries) {
        _.each(entries, function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          var elem = entry.target;

          self.attachReal(elem);
        });
      };
      var options = {
        root: null,
        rootMargin: '0px',
        threshold: [0.1]
      };

      self.observer = new IntersectionObserver(handler, options);
    },
    attach: function ($context) {
      /*
       * Lazy load the shade picker
       */
      var self = this;
      var highlightOutStockShade = false;

      this.setupObserver();

      var $shadepickers = $('.js-product-shade-picker', $context);

      $shadepickers.each(function (i, obj) {
        self.observer.observe(obj);
      });

      highlightOutStockShade = $shadepickers.hasClass('highlight-out-stock-shade');

      if (highlightOutStockShade && prodcat.data && prodcat.data.store) {
        $.each(prodcat.data.store.skus, function (index, product) {
          // Key - Out of Stock(2), Sold Out (7)
          if ([2, 7].includes(product.INVENTORY_STATUS)) {
            $(".js-product-shade[data-sku='" + product.SKU_ID + "']").addClass('cross-out-shade');
          }
        });
      }
    },

    // Route path for shade family selection.
    shadeFamilyRoute: '/sf/',

    // eslint-disable-next-line complexity
    matchShadeFamilyFromHash: function ($menuLinks) {
      var shadeFamilyRoute = this.shadeFamilyRoute;

      if (!window.location.hash || !shadeFamilyRoute || !$menuLinks || $menuLinks.length === 0) {
        return;
      }

      var hash = window.location.hash.substring(1);

      if (hash.substring(0, shadeFamilyRoute.length) !== shadeFamilyRoute) {
        return;
      }

      var parts = hash.substring(shadeFamilyRoute.length).split('/');
      var sfKey = parts[0];

      if (!sfKey) {
        return;
      }

      var matchInfo = {};
      var $match = null;

      $menuLinks.each(function (i, obj) {
        var $link = $(obj);
        var linkKey = $link.data('shade-family');

        if (linkKey === sfKey) {
          $match = $link;

          return false;
        }
      });

      if (!$match) {
        return null;
      }

      matchInfo.$matchedFamily = $match;

      // Also try to match shade if possible
      // So defaulting to sku in shade family would be
      // /sf/pink/sku/123
      if (parts.length === 3 && parts[1] === 'sku') {
        matchInfo.skuBaseId = parts[2];
      }

      return matchInfo;
    },
    // eslint-disable-next-line complexity
    attachReal: async function (shadepickerEl) {
      var self = this;

      // no longer wait for onscreen
      self.observer.unobserve(shadepickerEl);

      var $shadepicker = $(shadepickerEl);
      var $product = $shadepicker.closest('.js-product');

      var invStatus = parseInt($product.attr('data-inventory-status'), 10);
      var productShadeGrayed = Drupal.settings && Drupal.settings.common && Drupal.settings.common.product_shade_grayed;

      if ((invStatus === 2 || invStatus === 5 || invStatus === 7) && !productShadeGrayed) {
        $product.parent().addClass('product-shade-disabled');
        if (site.translations && site.translations.product) {
          $product
            .parents('.product-grid__item')
            .attr('title', site.translations.product.temp_out_of_stock_msg);
        }
      }

      // Wait for parent carousel to be initialized if nested
      await waitForParentInitialized($shadepicker);

      var bps = Unison?.fetch?.all() ?? {};
      var $slider = $('.product-shade-picker__shades', $shadepicker);

      sortTFShadesAndInventory($slider);

      // Clone $slider and insert this next to the original
      if ($shadepicker.find('.original-shade-picker').length === 0) {
        $slider
          .clone()
          .removeClass('product-shade-picker__shades')
          .addClass('original-shade-picker')
          .css('display', 'none')
          .attr('aria-hidden', 'true')
          .insertBefore($slider);
      }

      $slider.off('shadePicker:visible-shade-change').on('shadePicker:visible-shade-change', function () {
        var $this = $(this);
        if ($this.hasClass('slick-initialized')) {
          $this.slick('unslick');
          self.initializeSlick($this);
        }
      });
      // *
      // * Always initialize carousel on product-brief (PLP)
      // *
      var isProductBrief = $shadepicker.parent().hasClass(productBriefClass) || $shadepicker.closest('.' + productBriefClass).length > 0;
      var isProductFull = $shadepicker.parent().hasClass(productFullClass) || $shadepicker.closest('.' + productFullClass).length > 0;

      if (isProductBrief) {
        self.initializeSlick($slider);
        if (!$product.data('disable-shade-carousel')) {$shadepicker.addClass('slider');
        }
      } else if (isProductFull) {
        // *
        // * If enabled, on product full (PDP), initialize carousel on mobile
        // *
        if (enableMobileCarouselProductFull) {
          $(`.${productFullClass}`).addClass('product-full__shadepicker-carousel');
          _initProductFullCarouselMobile();
          _onResizeToggleCarousel();
        }
      }

      function _initProductFullCarouselMobile() {
        const bp = Unison?.fetch?.now()?.width ?? '';
        if (bp !== bps.landscape) {
          if (!$slider.hasClass('slick-initialized')) {
            $shadepicker.addClass('slider');
            self.initializeSlick($slider);
          }
        } else {
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
            $shadepicker.removeClass('slider');
          }
        }
      }

      function _onResizeToggleCarousel() {
        Unison.on('change', function () {
          _initProductFullCarouselMobile();
        });
      }

      $product.off('shadePicker:selectShade').on('shadePicker:selectShade', function (e, skuBaseId) {
        var $activeShade = $('.js-product-shade[data-sku="SKU' + skuBaseId + '"]', $product);

        _setSmooshColor(skuBaseId, $product);

        $('select.js-sku-menu', $product).val(skuBaseId);

        $('.js-product-shade', $product).removeClass('active');
        $activeShade.addClass('active');

        // *
        // * If shadepicker is in a carousel and not product_brief,
        // * Ensure the active shade is centered when selected from the SelectBox.
        // *
        var isProductBrief = $shadepicker.parent().hasClass(productBriefClass);
        if ($shadepicker.hasClass('slider') && !isProductBrief) {
          var $sliderInst = $shadepicker.find('.product-shade-picker__shades');
          if ($sliderInst.hasClass('slick-initialized')) {
            var slideIdx = $activeShade.closest('.js-shade-picker-item').data('slick-index');
            if (typeof slideIdx !== 'undefined' && slideIdx !== null) {
              $sliderInst.slick('slickGoTo', parseInt(slideIdx, 10));
            }
          }
        }
        if (!isProductBrief) {
          $product.trigger('shadePicker:ensureActiveFamily', [$product]);
        }
      });

      // See if we have a matching shade family route. If so, simulate click
      // then opt out of default shade selection.
      var $menuLinks = $('.product-shade-picker__shade_family', $product);
      var matchInfo = this.matchShadeFamilyFromHash($menuLinks);

      if (matchInfo) {
        if (matchInfo.skuBaseId) {
          $product.trigger('product.skuSelect', [matchInfo.skuBaseId, true]);
        }
        matchInfo.$matchedFamily.trigger('click');

        return;
      }

      // default to current skubaseid on load
      if ($product.data('sku-base-id')) {
        var skuBaseId = $product.data('sku-base-id');

        if (isSoldOutReorderingEnabled()) {
          var currentSkuData = (typeof prodcat !== 'undefined') ? prodcat.data.getSku('SKU' + skuBaseId) : null;

          if (currentSkuData && (currentSkuData.INVENTORY_STATUS === 2 || currentSkuData.INVENTORY_STATUS === 7)) {
            var $firstInStock = $slider.find('.js-shade-picker-item:not(.shade-hidden)').first().find('.js-product-shade');
            if ($firstInStock.length) {
              var inStockSku = $firstInStock.data('sku');
              if (inStockSku) {
                skuBaseId = inStockSku.replace('SKU', '');
                $product.attr('data-sku-base-id', skuBaseId);
                $product.data('sku-base-id', skuBaseId);
              }
            }
          }
        }

        $product.triggerHandler('shadePicker:selectShade', [skuBaseId]);
        $product.trigger('product.skuSelect', [skuBaseId]);
      }

      $shadepicker.trigger('shadePicker:visible-shade-change');
    },

    initializeSlick: function ($shadepicker) {
      var self = this;
      var shadeItem = '.product-shade-picker__shade-item:not(.shade-hidden)';
      var inNestedCarousel = $shadepicker.closest('.js-product-carousel').length > 0;
      var isFeatureEnabled = isSoldOutReorderingEnabled();

      var $parentPicker =$shadepicker.closest('.product-brief__shade-picker');

      if (!$parentPicker.length) {
         $parentPicker =$shadepicker.closest('.js-product-shade-picker, .product-full__shadepicker, .js-shadepicker');
      }

      var customPrevArrow = '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" tabindex="0" style="font-size: 0; color: transparent;"></button>';
      var customNextArrow = '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" tabindex="0" style="font-size: 0; color: transparent;"></button>';

      var settings = {
        infinite: false,
        appendArrows: $parentPicker,
        prevArrow: customPrevArrow,
        nextArrow: customNextArrow,
        autoplay: false,
        centerMode: false,
        centerPadding: '0px',
        focusOnSelect: false,
        accessibility: false,
        lazyLoad: 'progressive',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: slidesToShowResponsive,
              slidesToScroll: slidesToShowResponsive,
            }
          }
        ],
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToShow,
        slide: shadeItem,
        swipe: !inNestedCarousel,
        swipeToSlide: !inNestedCarousel,
        rows: 0
      };

      if ($shadepicker.data('slick-timeout')) {
        clearTimeout($shadepicker.data('slick-timeout'));
      }

      if (!$shadepicker.hasClass('slick-initialized')) {

        $shadepicker
          .off('.shadePickerEvents')
          .on('init.shadePickerEvents', function (event, slick) {
            setTimeout(function () {
              self.sliderGoToSelected(slick, $shadepicker, shadeItem);
            }, 50);
          })
          .on('afterChange.shadePickerEvents', function () {
            var activeShade = $shadepicker.find('.js-product-shade.active').attr('data-sku');
            if (activeShade) {
              $shadepicker.find(`.js-product-shade[data-sku='${activeShade}']`).addClass('active');
            }
          })
          .slick(settings);
      } else {
        $shadepicker.slick('setPosition');
      }

    },

    sliderGoToSelected: function (slick, $shadepicker, shadeItem) {
      var selectedSku = $shadepicker.closest('.js-product').attr('data-sku-base-id');
      var $defaultShadeItem = $shadepicker
        .find(`.js-product-shade[data-sku=SKU${selectedSku}]`)
        .closest('.js-shade-picker-item');
      // initialSlide doesn't work with responsive config, so have to set it here.
      var isScrollable = slick.$slides.length > slick.options.slidesToShow;

      if (isScrollable && $defaultShadeItem.length) {
        var slideIndex = $defaultShadeItem.data('slick-index');
        if (typeof slideIndex !== 'undefined' && slideIndex !== null) {
          $shadepicker.slick('slickGoTo', parseInt(slideIndex, 10));
        }
      }

      $defaultShadeItem.find('.js-product-shade').addClass('active');

    }
  };
})(jQuery, Unison);
